<template>
  <span>
    <template v-for="(segment, idx) in segments" :key="idx">
      <mark v-if="segment.matched" class="search-highlight">{{ segment.text }}</mark>
      <template v-else>{{ segment.text }}</template>
    </template>
  </span>
</template>

<script setup>
import { computed } from 'vue';
import { buildHighlightSegments } from '../lib/highlightSegments';

const props = defineProps({
  text: {
    type: String,
    default: '',
  },
  keyword: {
    type: String,
    default: '',
  },
});

const segments = computed(() => buildHighlightSegments(props.text, props.keyword));
</script>
